import { install } from "@material-ui/styles";
// migrations style to use new package from material ui
install();